<template>
  <div class="payment-receipt__wrap" id="receipt">
    <header class="layout--margin-bottom-xl">
      <h1 class="payment-receipt__title" v-if="receipt.stripeChargeId.lastIndexOf('WA_',0) > 0">Payment Receipt</h1>
      <h1 v-else class="payment-receipt__title">Invoice</h1>
      <table class="payment-receipt__table" style="border: none;">
        <tbody>
          <tr>
            <td width="50%" style="border: none">
              <address>
                <p class="payment-receipt__table-content">MotionMail &nbsp;</p>
                <p class="payment-receipt__table-content">
                  3 MacArthur Place, Ste 430 &nbsp;
                </p>
                <p class="payment-receipt__table-content">
                  Santa Ana, CA 92707 &nbsp;
                </p>
                <p class="payment-receipt__table-content">
                  (888) 261-7414
                </p>
              </address>
            </td>
            <td width="50%" style="border: none; vertical-align: top;">
              <span
                ><img
                  src="../assets/icons/logo.png"
                  alt="Motion Mail"
                  class="payment-receipt__logo"
              /></span>
            </td>
          </tr>
        </tbody>
      </table>
    </header>
    <article class="layout--margin-bottom-lg">
      <table class="payment-receipt__table" style="border: none;">
        <tbody>
          <tr>
            <td
              width="25%"
              style="border: none; vertical-align: top;overflow: hidden;"
            >
              <span style="display: block;" class="text-size-md weight--bold">
                {{ user.firstName }} {{ user.lastName }} <br /><br />
                {{ customer.companyName }}
                <br />
                <span v-if="customer.companyAddress"
                  v-html="customer.companyAddress.replace(/\n/g, '<br>')"
                ></span>
              </span>
            </td>
            <td width="75%" style="border: none">
              <table
                class="payment-receipt__sub-table layout--margin-bottom-xl"
              >
                <tbody>
                  <tr>
                    <th
                      class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
                    >
                      <span>Invoice #</span>
                    </th>
                    <td class="payment-receipt__sub-table-cell">
                        <span>{{ invoiceNumber }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
                    >
                      <span>VAT</span>
                    </th>
                    <td class="payment-receipt__sub-table-cell">
                      <span>{{ customer.vat }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
                    >
                      <span>Date</span>
                    </th>
                    <td class="payment-receipt__sub-table-cell">
                      <span>{{ receipt.createdAt | fancyDate }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th
                      class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
                    >
                      <span
                        >{{
                          transactionType | capitalizeFirstLetter
                        }}
                        Amount</span
                      >
                    </th>
                    <td class="payment-receipt__sub-table-cell">
                      <span>{{ receipt.transactionAmount | currency }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="payment-receipt__table">
        <thead>
          <tr>
            <th class="payment-receipt__table-header">
              <span>Item</span>
            </th>
            <th class="payment-receipt__table-header">
              <span>Description</span>
            </th>
            <th class="payment-receipt__table-header">
              <span>Rate</span>
            </th>
            <th class="payment-receipt__table-header">
              <span>Qty</span>
            </th>
            <th class="payment-receipt__table-header">
              <span>Price</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="receipt.subscriptionAmount > 0">
            <td class="payment-receipt__table-data">
              <span>Plan charge</span>
            </td>
            <td class="payment-receipt__table-data">
              <span
                >{{ receipt.subscriptionName }} ({{
                  billingCycle | capitalizeFirstLetter
                }})</span
              >
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.subscriptionAmount | currency }}</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>1</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.subscriptionAmount | currency }}</span>
            </td>
          </tr>
          <tr v-if="receipt.overageAmount > 0">
            <td class="payment-receipt__table-data">
              <span>Plan overage</span>
            </td>
            <td class="payment-receipt__table-data">
              <span>Overage fee</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.overagePerCreditAmount }}</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.creditOverage }}</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.overageAmount }}</span>
            </td>
          </tr>
          <tr v-if="transactionType === 'refund'">
            <td class="payment-receipt__table-data">
              <span>Plan change</span>
            </td>
            <td class="payment-receipt__table-data">
              <span>Refund</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.transactionAmount | currency }}</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>NA</span>
            </td>
            <td
              class="payment-receipt__table-data payment-receipt__table-data--right"
            >
              <span>{{ receipt.transactionAmount | currency }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="payment-receipt__sub-table">
        <tbody>
          <tr>
            <th
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
            >
              <span>Total</span>
            </th>
            <td
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-cell--right"
            >
              <span>{{ receipt.transactionAmount | currency }}</span>
            </td>
          </tr>
          <tr v-if="receipt.stripeChargeId.lastIndexOf('WA_',0) > 0">
            <th
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
            >
              <span>Amount Paid</span>
            </th>
            <td
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-cell--right"
            >
              <span>{{ receipt.transactionAmount | currency }}</span>
            </td>
          </tr>
          <tr>
            <th
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-header"
            >
              <span>Balance Due</span>
            </th>
            <td
              class="payment-receipt__sub-table-cell payment-receipt__sub-table-cell--right"
            >
              <span v-if="receipt.stripeChargeId.lastIndexOf('WA_',0) > 0">{{ 0 | currency }}</span>
              <span v-else> {{ receipt.transactionAmount | currency }} </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="clear:both;"></div>
    </article>
    <aside>
      <h2 class="payment-receipt__sub-title">Additional Notes</h2>
      <p class="text-size-default">{{ receipt.memo }}</p>
    </aside>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getBillingTransactionTypeDescription,
  getBillingCycleDescription,
} from "../helpers/helpers";
import Logo from "../assets/icons/img-logo.svg";

export default {
  name: "payment-receipt",
  components: { Logo },
  mounted: function() {
    window.print();
  },
  computed: {
    ...mapGetters("account", ["paymentReceipt", "customer", "user"]),
    receipt: function() {
      return this.paymentReceipt(parseInt(this.$route.query.id));
    },
    invoiceNumber: function() {
      // add leading zeros
      const newNumber = "0000000" + this.receipt.id;
      return newNumber.substr(newNumber.length - 7);
    },
    transactionType: function() {
      return getBillingTransactionTypeDescription(this.receipt.transactionType);
    },
    billingCycle: function() {
      return getBillingCycleDescription(this.receipt.billingCycle);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/pages/paymentReceipt.scss";
</style>
